/** Phase 22 — stockMovements-Ledger lesen. */

import { listAggregateStockMovements } from '../infrastructure/storage/domainAggregateStore';
import { listEntityStockMovements } from '../infrastructure/storage/entityAggregateStore';
import { createArrayEntityReadSource } from './arrayEntityReadSourceFactory';

const source = createArrayEntityReadSource({
  field: 'stockMovements',
  listAggregate: listAggregateStockMovements,
  listEntity: listEntityStockMovements,
  idKeys: ['movementId', 'id']
});

export const readStockMovementsFromMergedBlob = source.readFromMergedBlob;
export const readStockMovementsFromBestSource = source.readFromBestSource;
export const refreshStockMovementsReadCache = source.refreshReadCache;
export const getCachedStockMovementsRead = source.getCachedRead;
export const clearStockMovementsReadCache = source.clearReadCache;
export const readStockMovementsSyncForBusiness = source.readSyncForBusiness;
